export const chatbotWidgetState = (state) => state.general?.openChatWidget;

export const bearerToken = (state) => state.general?.bearerToken;

export const rememberedConsent = (state) => state.general?.rememberedConsent ?? {};

const NO_ANNOUNCEMENTS_SEEN = [];

export const selectAnnouncementCompanyKey = (state) =>
    state?.auth?.userData?.user?.company?.uuid ?? null;

export const selectSeenAnnouncements = (state) => {
    const seen = state.general?.seenAnnouncements;
    const companyKey = selectAnnouncementCompanyKey(state);
    if (!companyKey || !seen || Array.isArray(seen)) return NO_ANNOUNCEMENTS_SEEN;
    return seen[companyKey] ?? NO_ANNOUNCEMENTS_SEEN;
};

export const isVerifyEmailOptionVisible = (state) => state.general?.isVerifyEmailOptionVisible;

export const verifyEmailTimer = (state) => state.general?.verifyEmailTimer;

export const companyInformation = (state) => state?.auth?.userData?.user?.company ?? {};

export const selectSetupGuideStatus = (state) => state?.apiCall?.setupGuideStatus;

export const selectEnvironmentWarning = (state) => state?.apiCall?.showEnvironmentWarning;

export const selectUserRole = (state) => state?.auth?.userData?.user?.type ?? '';

// The three status flags that mark onboarding as "done" — used to auto-skip the guide for
// already-onboarded owners on load and to reveal the "Go to Dashboard" button in the guide.
export const isSetupGuideComplete = (status) =>
    Boolean(status?.agreementSigned && status?.workflowAdded && status?.accountActivated);

// The guide is "active" (occupying Home) for a company owner who hasn't dismissed it this
// session. Existing, already-complete owners are marked dismissed once on Home load
// (see Home/index.jsx), so the completeness check is intentionally not reactive here.
export const selectIsSetupGuideActive = (state) => {
    const user = state?.auth?.userData?.user;
    const isCompanyOwner = user?.type === 'company_owner';
    const marked = state?.apiCall?.setupGuideMarkedAsComplete;

    return isCompanyOwner && !marked;
};
